import type { ListingOwnerGoodFor, UpdateListingOwnerGoodForRequest } from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export const listingGoodForApi = {
  async get(businessId: string, listingId: string): Promise<ListingOwnerGoodFor> {
    const res = await api.api.businesses[':businessId'].listings[':id']['good-for'].$get({
      param: { businessId, id: listingId },
    })
    return unwrap<ListingOwnerGoodFor>(res)
  },

  async update(
    businessId: string,
    listingId: string,
    request: UpdateListingOwnerGoodForRequest,
  ): Promise<ListingOwnerGoodFor> {
    const res = await api.api.businesses[':businessId'].listings[':id']['good-for'].$put({
      param: { businessId, id: listingId },
      json: request,
    })
    return unwrap<ListingOwnerGoodFor>(res)
  },
}
